import React, { Suspense, lazy } from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import AboutMe, { Props as WidgetProps } from './AboutMe';
import reduxConnectContainer from './AboutMe.container';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';

import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import s from './AboutMeBoxWide.scss';

const AboutMeEditPopup = lazy(() =>
  import(/* webpackChunkName: "owner" */ './AboutMeEditPopup')
);

const enhance = compose(
  reduxConnectContainer,
  withMobileContext,
  withTranslation()
);

class AboutMeInExpandedWidgetContainer extends React.Component<
  WidgetProps & WidgetBoxWideProps & WithTranslation & { isMobile?: boolean }
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      isMobile,
      widgetBoxClassName,
      parentRef,
      section,
      zone,
      ...props
    } = this.props;

    const header = isMobile ? (
      props.t!('widgets.aboutMe.header')
    ) : (
      <UserLink
        user={props.user}
        symbolClassName={s['user-symbol']}
        withTooltip={false}
      />
    );

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        id={id}
        header={header}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        moduleId={props.moduleId}
        widgetMenuRenderer={this.renderEditModal}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        parentRef={parentRef}
      >
        <AboutMe {...props} />
      </WidgetBoxWide>
    );
  }

  renderEditModal = closeModal => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <AboutMeEditPopup
          username={this.props.user.username}
          moduleId={this.props.moduleId}
          onClose={closeModal}
        />
      </Suspense>
    );
  };
}

export default enhance(AboutMeInExpandedWidgetContainer) as React.ComponentType<
  Pick<
    WidgetBoxWideProps,
    | 'moduleId'
    | 'id'
    | 'isHeaderStickyOnMobile'
    | 'subHeader'
    | 'headerExtraElementsOnMobile'
  >
>;
